var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIconGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0107 10.2324H18.0107V7.23242",
    stroke: "#747474",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8891 15.8891C15.1199 16.6583 14.1399 17.1821 13.073 17.3943C12.0061 17.6065 10.9002 17.4976 9.89524 17.0813C8.89025 16.6651 8.03126 15.9601 7.42692 15.0556C6.82257 14.1512 6.5 13.0878 6.5 12C6.5 10.9122 6.82257 9.84884 7.42692 8.94437C8.03126 8.0399 8.89025 7.33495 9.89524 6.91867C10.9002 6.50238 12.0061 6.39346 13.073 6.60568C14.1399 6.8179 15.1199 7.34173 15.8891 8.11092L18.0104 10.2322",
    stroke: "#747474",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIconGrey);
export default __webpack_public_path__ + "static/media/refresh-icon-grey.d8a2b132ac2b4845c546682c3ae66f76608ed98cf580b09e2dcb73f97bd6ab90.svg";
export { ForwardRef as ReactComponent };